<template>
  <div class="poster">
    <div class="content" v-if="detailData" id="result">
      <div class="top">
        <div class="user-info">
          <AutosizeImage
            :src="detailData.user_head"
            class="avatar"
          ></AutosizeImage>
          <div class="user-center">
            <div class="nickname">{{ detailData.truename }}</div>
            <div class="camp">{{ detailData.product_alias_name }}</div>
          </div>
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
            alt=""
          />
        </div>
        <div class="camp-info">
          <div class="c-item">
            <div class="text">
              <div>打卡</div>
              <div class="unit">(次数)</div>
            </div>
            <div class="num">{{ detailData.click_data.realityClickNum }}</div>
          </div>
          <div class="c-item">
            <div class="text">
              <div>体重</div>
              <div class="unit">(斤)</div>
            </div>
            <div class="num">
              <span
                class="iconfont icon-xingzhuangjiehebeifen"
                :class="{ rotate: bodyData[0].changeData > 0 }"
              ></span
              >{{ (bodyData[0].changeData * 2) | filterNum }}
            </div>
          </div>
          <div class="c-item">
            <div class="text">
              <div>腰围</div>
              <div class="unit">(厘米)</div>
            </div>
            <div class="num">
              <span
                class="iconfont icon-xingzhuangjiehebeifen"
                :class="{ rotate: bodyData[0].changeData > 0 }"
              ></span
              >{{ bodyData[1].changeData | filterNum }}
            </div>
          </div>
        </div>
        <div class="image-content">
          <div class="image-item before" v-if="detailData.start_life_img[0]">
            <div class="flag">入营前</div>
            <div class="compare-image-content compare-flex">
              <AutosizeImage
                :src="detailData.start_life_img[0]"
                class="compare-image compare-flex-imgae"
              ></AutosizeImage>
              <img
                class="logo"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_watermark"
                alt=""
              />
            </div>
          </div>
          <div class="image-item after" v-if="detailData.end_life_img[0]">
            <div class="flag">结营后</div>
            <div class="compare-image-content compare-flex">
              <img
                class="logo"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_watermark"
                alt=""
              />
              <AutosizeImage
                :src="detailData.end_life_img[0]"
                class="compare-image compare-flex-imgae"
              ></AutosizeImage>
            </div>
          </div>
        </div>
        <div class="n-info" v-if="coachInfo && coachInfo.head_portrait">
          <AutosizeImage
            :src="coachInfo.head_portrait"
            class="n-avatar"
          ></AutosizeImage>
          <div class="n-center">
            <div class="desc">高级营养师</div>
            <div class="nickname">{{ coachInfo.name }}</div>
          </div>
          <div class="serve-info">
            <div class="desc">服务人数</div>
            <div class="num">{{ coachInfo.members }}</div>
          </div>
          <div class="loss-info">
            <div class="desc">帮助减重（斤）</div>
            <div class="num">{{ coachInfo.weights }}</div>
          </div>
        </div>
        <div class="tips">
          * 本案例仅限betterWE注册学员内部交流分享，严格禁止商用外传
        </div>
      </div>
      <div class="bottom">
        <div class="b-left">
          <div>跟着营养师吃就瘦了</div>
          <div class="text2">扫码免费领取同款减脂方案</div>
        </div>
        <img
          class="qrcode"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0b6ce2b8a8dc8d40ac0f7030c57f09c0.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import AutosizeImage from './autosize-image.vue'
export default {
  components: {
    AutosizeImage
  },
  props: {
    detailData: {
      type: Object,
      default: null
    },
    coachInfo: {
      type: Object,
      default: null
    },
    bodyData: {
      type: Array,
      default: []
    }
  },
  filters: {
    filterCampTime(str) {
      return str.replace(/-/g, '.')
    },
    filterNum(num) {
      if (num < 0) {
        num = -num
      }
      return num
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.poster {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -1;
  opacity: 0;
  .content {
    width: 335px;
    border-radius: 8px;
    overflow: hidden;
    .top {
      padding: 17px 16px;
      background-color: #fff;
      .user-info {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        .avatar {
          width: 36px;
          height: 36px;
          margin-right: 8px;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          .avatar-image {
            width: 100%;
          }
        }
        .user-center {
          margin-right: 8px;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          .nickname {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .camp {
            white-space: nowrap;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.3);
            line-height: 17px;
          }
        }
        .logo {
          width: 71px;
          height: 12px;
          object-fit: contain;
        }
      }
      .camp-info {
        display: flex;
        align-items: center;
        background: rgba(98, 54, 255, 0.05);
        border-radius: 8px;
        padding: 9px 0px 7px;
        margin-bottom: 10px;
        .c-item {
          position: relative;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          .text {
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5c4378;
            line-height: 11px;
            .unit {
              margin-top: 2px;
              font-size: 8px;
            }
          }
          .num {
            font-size: 26px;
            font-family: DINCondensed-Bold, DINCondensed;
            font-weight: bold;
            color: #6236ff;
            margin-left: 6px;
            display: flex;
            align-items: center;
            .iconfont {
              font-size: 12px;
              margin-right: 6px;
            }
            .rotate {
              transform: rotate(180deg);
            }
          }
        }
        .c-item::after {
          content: '';
          position: absolute;
          width: 1px;
          height: 16px;
          background-color: #e1e1e1;
          right: 0;
          top: 50%;
          margin-top: -8px;
        }
        .c-item:last-child::after {
          display: none;
        }
      }
      .image-content {
        box-sizing: border-box;
        display: flex;
        border-radius: 12px;
        overflow: hidden;
        height: 226px;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
        .line {
          border: 1px solid #e7e7e7;
          width: 0;
          height: 100%;
        }
        .compare-image-content {
          position: relative;
          height: 100%;
          .logo {
            opacity: 0.3;
            width: 68px;
            position: absolute;
            right: 10px;
            bottom: 10px;
          }
          .compare-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .compare-flex {
          display: flex;
          align-items: center;
          justify-content: center;
          .compare-flex-imgae {
            width: 100%;
            height: 100%;
          }
        }
        .image-item {
          width: 50%;
          height: 100%;
          box-sizing: border-box;
          background: #fff;
          border-radius: 1px;
          overflow: hidden;
          position: relative;
          .flag {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            position: absolute;
            top: 0;
            width: 64px;
            height: 22px;
            line-height: 22px;
            text-align: center;
          }
          .time {
            position: absolute;
            bottom: 11px;
            font-size: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 14px;
          }
        }
        .before {
          border-radius: 12px 0px 0px 12px;
          overflow: hidden;
          .flag {
            left: 0;
            background: #5c4378;
            border-radius: 6px 0px 6px 0px;
            z-index: 2;
          }
          .time {
            left: 15px;
          }
        }
        .after {
          border-radius: 0px 12px 12px 0px;
          overflow: hidden;
          .flag {
            right: 0;
            z-index: 2;
            background: linear-gradient(8deg, #f44aff 0%, #6236ff 100%);
            border-radius: 0px 8px 0px 8px;
          }
          .time {
            right: 15px;
          }
        }
      }
      .n-info {
        display: flex;
        padding: 12px 5px 12px 10px;
        background: #f7f7f7;
        border-radius: 8px;
        margin-bottom: 10px;
        .n-avatar {
          width: 36px;
          height: 36px;
          border-radius: 6px;
          overflow: hidden;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          .n-avatar-image {
            width: 100%;
          }
        }
        .n-center {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }
        .desc {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 14px;
        }
        .nickname {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }
        .num {
          margin-top: 5px;
          height: 18px;
          font-size: 18px;
          font-family: DINCondensed-Bold, DINCondensed;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 15px;
        }
        .serve-info {
          text-align: center;
          position: relative;
          padding: 0px 10px;
        }
        .serve-info::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0%, -50%);
          width: 1px;
          height: 26px;
          background-color: #ebebeb;
        }
        .loss-info {
          padding-left: 5px;
          text-align: center;
        }
      }
      .tips {
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
      }
    }
    .bottom {
      padding: 18px 16px;
      background: #f1f1f1;
      border-radius: 0px 0px 8px 8px;
      display: flex;
      align-items: center;

      .b-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        .text2 {
          font-weight: 600;
          font-size: 14px;
        }
      }
      .qrcode {
        width: 64px;
        height: 64px;
        margin-left: 10px;
      }
    }
  }
}
</style>
